import { physicianAgreement } from "@docio/shared";
import { LegalDocumentPage } from "@/components/LegalDocumentPage";

const PhysicianTerms = () => (
  <LegalDocumentPage
    doc={physicianAgreement}
    seoTitle="Physician Agreement"
    seoDescription="The Platform-Physician Agreement governing independent medical practitioners providing services through Docio Health."
    chromeKey="physicianTerms"
    banner={{
      textKey: "physicianTerms.patientBanner.text",
      ctaKey: "physicianTerms.patientBanner.cta",
      to: "/terms-of-service",
    }}
  />
);

export default PhysicianTerms;
